export default "__VITE_ASSET__81iA7QE4__"